import {
  ActionBody,
  Columnz,
  DataTablez,
  RenderHeader,
  StatusBody,
  TimeBody,
  useGetParams,
} from "@/components/DataTable";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { confirmDialog } from "primereact/confirmdialog";
import { showToast } from "@/redux/features/toast";
import { listToast } from "@/utils";
import { updateSheet, updateSheetDetail } from "../../list_sheet/api";
import { Button, Dialog, Dropdown } from "@/uiCore";
import { useCountListPageFB, useListPageFB } from "../util";
import { updateListPageFB, updatePageFB, updateStatusPageFB } from "../api";
import { useNavigate } from "react-router-dom";
import { useListCategory } from "@/modules/categories/category/util";

const ListPageFacebook = () => {
  const initParams = useGetParams();
  const [paramsPaginator, setParamsPaginator] = useState(initParams);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [infos, setInfos] = useState({});
  const navigate = useNavigate();
  const listCategory = useListCategory({ ...paramsPaginator });
  const list = useListPageFB({ ...paramsPaginator });
  const total = useCountListPageFB({ ...paramsPaginator });
  const dispatch = useDispatch();
  const header = RenderHeader({
    title: "Danh sách page Facebook",
    // exports: {
    //   route: "/list_sheet/export",
    //   action: () => exportRegisterNews(paramsPaginator),
    //   totalRecords: totalRecords,
    //   file: "list_sheet.xlsx",
    // },
  });
  const accept = async (id) => {
    await updateSheetDetail({ id: id });
    setParamsPaginator((pre) => ({ ...pre, render: !pre.render }));
    dispatch(
      showToast({
        ...listToast[0],
        detail: `Cập nhật dữ liệu thành công!`,
      })
    );
  };
  const confirm1 = (id) => {
    confirmDialog({
      message: "Xác nhận cập nhật thông tin form sheet này",
      header: "Xác nhận",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      accept: () => accept(id),
    });
  };
  const handleUpdateList = async () => {
    setLoading(true);
    await updateListPageFB();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    dispatch(
      showToast({
        ...listToast[0],
        detail: `Cập nhật dữ liệu Page - Form Facebook thành công!`,
      })
    );
    if (paramsPaginator && setParamsPaginator) {
      setParamsPaginator((pre) => {
        return { ...pre, render: !pre.render };
      });
    }
  };
  const handleCategory = (e) => {
    setVisible(true);
    setInfos({ ...e, ...infos });
  };
  const handleHide = () => {
    setVisible(false);
    setInfos({});
  };
  async function fetchDataSubmit() {
    const response = await updatePageFB({
      id: infos?.id,
      category_id: infos?.category_id,
    });
    if (response) setLoading(false);
    if (response.data.status) {
      dispatch(
        showToast({ ...listToast[0], detail: `Cập nhật thông tin thành công!` })
      );
      handleHide();
      setParamsPaginator((pre) => ({ ...pre, render: !pre.render }));
    } else dispatch(showToast({ ...listToast[1], detail: response.data.mess }));
  }

  const handleSubmit = () => {
    setLoading(true);
    // if (!infos?.category_id) {
    //   dispatch(showToast({ ...listToast[1], detail: "Vui lòng chọn dự án" }));
    //   setLoading(false);
    // } else {
    fetchDataSubmit();
    // }
  };
  const footerContent = (
    <div>
      <Button
        label="Hủy"
        icon="pi pi-times"
        onClick={() => handleHide()}
        className="p-button-text"
      />
      <Button
        label="Cập nhật"
        icon="pi pi-check"
        onClick={() => handleSubmit()}
        loading={loading}
        autoFocus
      />
    </div>
  );
  return (
    <div className="card">
      <Dialog
        header="Cập nhật thông tin trang tính"
        visible={visible}
        position="top"
        style={{ width: "60vw", height: "60vh" }}
        onHide={() => handleHide()}
        draggable={false}
        // resizable={false}
        footer={footerContent}
      >
        <label htmlFor="cate" className="">
          Dự án
        </label>
        <Dropdown
          id="cate"
          value={infos?.category_id}
          onChange={(e) => setInfos({ ...infos, category_id: e.target.value })}
          options={listCategory}
          optionLabel="cb_title"
          optionValue="cb_id"
          placeholder="Chọn dự án"
          className="w-full my-1"
          checkmark={true}
          highlightOnSelect={false}
        />
      </Dialog>
      <Button loading={loading} onClick={handleUpdateList}>
        Cập nhật page - form FB
      </Button>
      <DataTablez
        value={list}
        header={header}
        title="danh sách page facebook"
        totalRecords={total}
        paramsPaginator={paramsPaginator}
        setParamsPaginator={setParamsPaginator}
      >
        <Columnz field="page_name" header="Tên Page" />
        <Columnz
          body={(e) => (
            <div className="flex flex-row align-items-center">
              <span className="">{e?.cb_title}</span>
              <span
                className="pi pi-file-edit text-xl ml-2 cursor-pointer"
                onClick={() => handleCategory(e)}
              ></span>
            </div>
          )}
          header="Dự án"
        />
        <Columnz
          body={(e) => TimeBody(e?.created_at)}
          bodyStyle={{ textAlign: "center" }}
          header="Ngày tạo"
        />
        <Columnz
          body={(e) => TimeBody(e?.updated_at)}
          bodyStyle={{ textAlign: "center" }}
          header="Cập nhật gần nhất"
        />
        {/* <Columnz
            body={(e) => (
              <div className="flex flex-row">
                <Button
                  onClick={() => confirm1(e?.id)}
                  type="button"
                  icon="pi pi-wrench"
                  rounded
                  outlined
                  className={" mx-auto flex"}
                  severity={"info"}
                />
              </div>
            )}
            header="Chỉnh sửa URL"
          /> */}
        <Columnz
          body={(e) => (
            <div className="flex flex-row">
              <Button
                onClick={() => navigate(`/list_form_fb/${e?.page_id}`)}
                type="button"
                icon="pi pi-eye"
                rounded
                outlined
                className={" mx-auto flex"}
                severity={"info"}
              />
            </div>
          )}
          header="Danh sách form"
        />
        <Columnz
          header="Trạng thái"
          body={(e) =>
            StatusBody(e, {
              route: "/list_page_fb/update",
              action: updateStatusPageFB,
            })
          }
          bodyStyle={{ textAlign: "center" }}
        />
      </DataTablez>
    </div>
  );
};
export default ListPageFacebook;
